import React from 'react';

export function LoadingPage() {
  return (
    <div id='page-content h-full w-full'>
      <div className='relative'>
        <div id='box-container'>
          <div className='nextgen'>
            <div className='content'>
              <div className='flex space-x-2 p-5 rounded-full justify-center items-center'>
                <div
                  className='bg-turquoise-300 p-2 w-4 h-4 rounded-full animate-bounce'
                  style={{ animationDelay: '0.1s' }}
                ></div>
                <div
                  className='bg-turquoise-500 p-2 w-4 h-4 rounded-full animate-bounce'
                  style={{ animationDelay: '0.2s' }}
                ></div>
                <div
                  className='bg-turquoise-700 p-2 w-4 h-4 rounded-full animate-bounce'
                  style={{ animationDelay: '0.3s' }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
